import React from "react"
import RtlSvg from "@myvp/shared/src/icons/rtl-svg"
import { useTheme } from "@emotion/react"

const Undo = (props: { color?: "black" | "white" }) => {
  const theme = useTheme()

  return (
    <RtlSvg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 16.501C6.75 16.501 10.5 16.501 14.25 16.501C18 16.501 18.75 14.251 18.75 12.751C18.75 11.251 18 9.00098 14.25 9.00098C10.5 9.00098 8.25 9.00098 4.5 9.00098M4.5 9.00098C4.5 8.70801 7.5 6.00098 7.5 6.00098M4.5 9.00098C4.5 9.29395 7.5 12.001 7.5 12.001"
        stroke={
          props.color !== "black"
            ? theme.primitive.neutral[100]
            : theme.palette.content.neutral.default
        }
        strokeWidth="1.5"
      />
    </RtlSvg>
  )
}

export default Undo
